import * as uuid from "uuid";
import {getQtCatName} from "../../../../helpers/sqftQuotesHelper";

export class LineHandlesModel {
  lineId;
  id;
  featureId;
  qtCatName;

  constructor(lineId, handleId, qtCatName = null, id = uuid.v4()) {
    this.id = id;
    this.lineId = lineId;
    this.featureId = handleId;
    this.qtCatName = qtCatName ? qtCatName : getQtCatName();
  }
}
